import type { LucideIcon } from "lucide-react";
import {
  Building2,
  Users,
  BedDouble,
  Shield,
  Bell,
  User,
  LogOut,
  LayoutGrid,
  BarChart3,
  Store,
  LineChart,
  Link2,
  GitCompareArrows,
} from "lucide-react";

export type NavItem = {
  label: string;
  to?: string;
  icon?: LucideIcon;
  children?: NavItem[];
  action?: () => void;
};

export const adminMenu = (onLogout: () => void): NavItem[] => [
  { label: "Компании", to: "/companies", icon: Building2 },
  { label: "Пользователи", to: "/users", icon: Users },
  { label: "Объекты размещения", to: "/objects", icon: BedDouble },
  { label: "Конкуренты", to: "/competitors", icon: Shield },
  { label: "Маппинг", to: "/mapping", icon: Link2 },
  { label: "Профиль", to: "/account", icon: User },
  { label: "Выход", icon: LogOut, action: onLogout },
];

export const userMenu = (onLogout: () => void): NavItem[] => [
  { label: "Мои объекты размещения", to: "/my/objects", icon: LayoutGrid },
  {
    label: "Аналитика",
    icon: BarChart3,
    children: [
      { label: "Дашборд", to: "/analytics/dashboard", icon: BarChart3 },
      { label: "Календарь цен", to: "/analytics/date-delta", icon: GitCompareArrows },
      { label: "Паритет цен", to: "/analytics/platforms", icon: Store },
      { label: "Тренды по конкурентам", to: "/analytics/trends/competitors", icon: LineChart },
    ],
  },
  { label: "Уведомления", to: "/notifications", icon: Bell },
  { label: "Профиль", to: "/account", icon: User },
  { label: "Выход", icon: LogOut, action: onLogout },
];
